@if (isAuthenticated()) {
  <div
    class="c-align"
    [matMenuTriggerFor]="usermenu"
    data-testid="header-user-menu"
  >
    @if ($userInitials()) {
      <div class="large-icon">
        {{ $userInitials() }}
      </div>
    }
  </div>
}
<mat-menu #usermenu="matMenu">
  <button
    mat-menu-item
    data-testid="downloads-and-exports"
    routerLink="/user/downloads-exports"
    class="notification-button"
  >
    <mat-icon class="material-icons-outlined"> file_present</mat-icon>
    <span class="button-text">Downloads and Exports</span>
  </button>
  <button
    mat-menu-item
    routerLink="/user/profile"
    data-testid="user-profile-button"
  >
    <mat-icon> settings</mat-icon>My Profile
  </button>
  @if ($canViewMyOrganization()) {
    <button
      mat-menu-item
      routerLink="/organizations/{{ $organizationId() }}"
      data-testid="my-organization-button"
    >
      <mat-icon fontSet="material-icons-outlined"> business</mat-icon>My
      Organization
    </button>
    <mat-divider />
  }

  <button
    mat-menu-item
    data-testid="user-contact-us"
    class="notification-button"
    (click)="openContactDialog()"
  >
    <mat-icon class="material-icons-outlined"> send</mat-icon>
    <span class="button-text">Contact Us</span>
  </button>
  <button
    mat-menu-item
    data-testid="user-privacy-policy"
    routerLink="/user/privacy-policy"
    class="notification-button"
  >
    <mat-icon class="material-icons-outlined">policy</mat-icon>
    <span class="button-text">Privacy Policy</span>
  </button>
  <button mat-menu-item (click)="logout()" data-testid="user-logout-button">
    <mat-icon>logout</mat-icon>
    @if (isImpersonating()) {
      Stop Impersonating
    } @else {
      Sign Out
    }
  </button>

  @let irisVersion = $irisVersion();
  @let apiVersion = $apiVersion();
  @let releaseNumber = $releaseNumber();
  <mat-divider />
  <div class="version">
    @if (irisVersion || releaseNumber) {
      <div>
        {{ irisVersion }}{{ releaseNumber ? " v" + releaseNumber : "" }}
      </div>
    }
    @if (apiVersion && isInternal()) {
      <div class="text-xl text-gray-500">Build {{ apiVersion }}</div>
    }
  </div>
</mat-menu>
